import {
  ISSUE_DISPUTE_LOADING,
  ISSUE_DISPUTE_READY,
  ISSUE_DISPUTE_UNAUTHORIZED,
  ISSUE_DISPUTE_SUBMITTING,
  ISSUE_DISPUTE_CREATED,
  ISSUE_DISPUTE_ERROR
} from '../actions/issueDisputeActions';

const INITIAL_STATE = {
  issueDispute: null,
  error: null,
  status: null,
  authorized: null,
  existingDispute: null
};

export default function issueQuestionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ISSUE_DISPUTE_LOADING:
      return {
        ...state,
        status: 'LOADING',
        error: null,
        message: null,
        authorized: null,
        existingDispute: null,
        appointment: null
      };

    case ISSUE_DISPUTE_READY:
      return {
        ...state,
        status: 'READY',
        error: null,
        ...action.payload
      };

    case ISSUE_DISPUTE_UNAUTHORIZED:
      return {
        ...state,
        status: 'UNAUTHORIZED',
        message: action.payload.message,
        error: { message: action.payload.error }
      };

    case ISSUE_DISPUTE_SUBMITTING:
      return {
        ...state,
        status: 'SUBMITTING',
        message: null,
        error: null
      };

    case ISSUE_DISPUTE_CREATED:
      return {
        ...state,
        status: 'CREATED',
        issueDispute: action.payload,
        error: null,
        appointment: action.payload.appointment
      };

    case ISSUE_DISPUTE_ERROR:
      return {
        ...state,
        error: { message: action.payload.error },
        status: 'FAIL'
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/issueDisputeReducer.js